import "./styles/CollectionItem.scss";
import { ICollection } from "@/common/services/types";
import BookMarkIcon from "@/common/images/BookMarkIcon.svg";

interface ICollectionItem {
  addToCollections: (folderId: string) => void;
  collection: ICollection;
}

export const CollectionItem = (props: ICollectionItem) => {
  const {
    collection: {
      folderId,
      folderName,
      thumbs
    },
    addToCollections
  } = props;

  return (
    <div className="CollectionItem" onClick={() => addToCollections(folderId)}>
      <div className="CollectionItem-Img">
        <img src={thumbs ?? BookMarkIcon} width={48} height={48} alt={`Poster for ${folderName} collection`} />
      </div>
      <span className="CollectionItem-Title">{folderName}</span>
    </div>
  );
};
